export default __webpack_public_path__ + "static/media/pear.df54ccd5.mp4";